import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import pt from 'vuetify/lib/locale/pt'

Vue.use(Vuetify);

const opts = {
    lang: {
        locales: { pt },
        current: 'pt',
    },
    theme: {
        themes: {
            light: {
                primary: '#4e008d',
            },
            dark: {
                primary: '#4e008d',
            },
        },
    },
};

export default new Vuetify(opts);
